'use client'

import dynamic from 'next/dynamic';

const ReactPlayer = dynamic(() => import('react-player/lazy'));
//import projectTsFile = import('../../../public/realisations/project-ts.mp4')
//import projectTsFile from '../../../public/realisations/project-ts.mp4'

export default function VideoPlayer(props: any) {

  return(
    <div className="player-wrapper aspect-w-16 aspect-h-9">
      <ReactPlayer
        className="react-player fixed-bottom"
        url={props.file}
        width="100%"
        height="100%"
        controls={true}
      />
    </div>
  )

}